export default __webpack_public_path__ + "b1b44163ea5bca3ae1548cf3abbfeaf4.png";